// extracted by mini-css-extract-plugin
export default {"Box":"title-renderer-module__Box--pR5i2","Box_1":"title-renderer-module__Box_1--c_Kxi","Text":"title-renderer-module__Text--xc_OK"};